import { useMutation } from '@tanstack/react-query';

import { MutationFunction, useRequest } from '@frontend/api';

import {
  BulkConvertQuoteFilesToLineItemsVars,
  ConvertQuoteFileToLineItemData,
  ConvertQuoteFileToLineItemParams,
} from './types';

export const useBulkConvertQuoteFilesToLineItems: MutationFunction<
  ConvertQuoteFileToLineItemData,
  BulkConvertQuoteFilesToLineItemsVars,
  Record<string, never>,
  [ConvertQuoteFileToLineItemParams]
> = (params, { query, requestOptions, queryOptions } = {}) => {
  const { quoteId } = params;

  const request = useRequest(requestOptions);

  return useMutation(
    (requestData) => {
      const urlPath = `/quotes/files/${quoteId}/bulk_convert`;
      return request(urlPath, {
        query,
        init: {
          method: 'POST',
          body: requestData,
        },
      });
    },
    {
      ...queryOptions,
      mutationKey: ['quotes', 'bulkConvertQuoteFilesToLineItems'],
    },
  );
};
